import { Icon } from "@iconify/react/dist/iconify.js";

import ConfirmDialog from "./ConfirmDialog";

/**
 * Pieces the panel's editable lists share: how a sub-list reports being empty,
 * the wording every destructive confirmation uses, and the PINFL rule.
 *
 * Started life beside the client-system panels and moved here when the user
 * register needed the same PINFL check -- two screens keying on the same
 * 14-digit number had better agree on what one looks like.
 */

/** A block that is still loading, empty, or broken says so in one place. */
export const PanelBody = ({ loading, error, empty, emptyText, children }) => {
  if (loading)
    return (
      <div className="ms-state">
        <div className="ms-spinner" />
      </div>
    );
  if (error)
    return (
      <div className="ms-state">
        <Icon icon="tabler:alert-triangle" />
        <span>{error}</span>
      </div>
    );
  if (empty)
    return (
      <div className="ms-state">
        <span>{emptyText}</span>
      </div>
    );
  return children;
};

/**
 * ConfirmDialog ships with Cyrillic labels, inherited from the ERP panel this
 * design is ported from. This screen is Latin, so the wording is set once here
 * instead of at the six call sites that would otherwise each repeat it.
 */
export const Confirm = (props) => (
  <ConfirmDialog
    title="Rostdan ham oʻchirmoqchimisiz?"
    message="Ushbu amalni qaytarib boʻlmaydi."
    confirmLabel="Oʻchirish"
    cancelLabel="Bekor qilish"
    busyLabel="Bajarilmoqda..."
    {...props}
  />
);

/**
 * A PINFL is exactly 14 digits, and every grant in this system hangs off one.
 *
 * OneID returns no email address, so when the person finally signs in, their
 * PINFL is the only thing that can match them to a membership or a manager
 * grant made in advance. A PINFL with a typo is therefore not a cosmetic
 * problem: it produces a row that looks correct on this screen and silently
 * matches nobody, forever. Caught here so the mistake is visible while the
 * field is still open, rather than as a 400 after the modal has been filled in.
 */
export const PINFL_LENGTH = 14;

export const isPinfl = (value) =>
  new RegExp(`^[0-9]{${PINFL_LENGTH}}$`).test((value || "").trim());

/** Save / cancel, in the order the design's modals use. */
export const ModalFoot = ({
  onCancel,
  onSave,
  saving,
  saveLabel = "Saqlash",
  savingLabel = "Saqlanmoqda...",
  disabled = false,
}) => (
  <>
    <button type="button" className="ms-btn ms-btn--ghost" onClick={onCancel} disabled={saving}>
      Bekor qilish
    </button>
    <button
      type="button"
      className="ms-btn ms-btn--primary"
      onClick={onSave}
      disabled={saving || disabled}
    >
      {saving ? savingLabel : saveLabel}
    </button>
  </>
);

/** The inline complaint under a modal's fields. */
export const FormError = ({ children }) =>
  children ? (
    <div className="ms-formerror">
      <Icon icon="tabler:alert-circle" />
      <span>{children}</span>
    </div>
  ) : null;
